module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (3).a019440f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (3).jpg
// module id = 342
// module chunks = 0